import React from 'react';
import { View, StyleSheet, StyleProp, ViewStyle, Text, TextStyle } from 'react-native';
import { COLORS } from '../../constants/colors';
import { textStyles } from '../../constants/textStyles';
import { MB_Image, mbGetSmallestImage } from '@workingu/rnw.components.image';
import { mbTextStyles } from '@workingu/rnw.utils.style-utils';
import { Image } from '../../typesAndInterfaces/typesAndInterfaces';
import { EmptyProfileIconSvg } from '../../resources/svgComponents/EmptyProfileIconSvg';

interface IProfileIcon {
    containerStyle?: StyleProp<ViewStyle>,
    image: Image | undefined,
    firstName: string | undefined,
    lastName: string | undefined,
    fontStyle?: StyleProp<TextStyle>,
}

const ProfileIcon = ({ containerStyle, image, firstName, lastName, fontStyle }: IProfileIcon) => {
    const profileImage = mbGetSmallestImage(image, { asUri: true });

    if (profileImage) {
        return (
            <View style={[styles.container, containerStyle]}>
                <MB_Image style={styles.imageStyle} source={profileImage} disableInteraction />
            </View>
        );
    }

    return (
        <View style={[styles.container, containerStyle]}>
            {firstName && lastName ?
                <Text style={[styles.noImageText, fontStyle]}>{firstName.charAt(0)}{lastName.charAt(0)}</Text>
                :
                <EmptyProfileIconSvg containerStyle={{ width: '100%', height: '100%' }} />
            }
        </View>
    );
};

export { ProfileIcon };

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        width: 35,
        height: 35,
        borderRadius: 300,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: COLORS.darkPurple,
        overflow: 'hidden',
    },
    imageStyle: {
        width: '100%',
        height: '100%',
    },
    noImageText: mbTextStyles([
        textStyles.normalText, {
            fontWeight: 'bold',
        },
    ]),
});
